import { NavigationService } from './../services/navigation-service.service';
import { Component, Input, OnInit } from '@angular/core';
import { IAppSettings, ILink } from '../models/common-model-interface';

@Component({
  selector: 'gn-mobile-nav',
  templateUrl: './mobile-nav.component.html',
  styleUrls: ['./mobile-nav.component.scss']
})
export class MobileNavComponent implements OnInit {
  @Input() accountLinks: Array<ILink>;
  @Input() userName: string;
  @Input() primaryNavs: Array<ILink>;
  @Input() globalLinks: Array<ILink>;
  @Input() appSettings: IAppSettings;
  @Input() registerUrl: string;
  @Input() homeUrl: string;
  @Input() alertsUrl: string;
  @Input() domain: string;

  constructor(public navigationService: NavigationService) {}
  @Input() feedbackSSOId: string;
  ngOnInit(): void {}

  OpenSurveyWindow(): void {
    this.navigationService.OpenSurveyWindow(this.feedbackSSOId);
  }
}
